import { Confirm, Export } from "./components";
import instance from "./instance";
import BaseModal from "./Modal";

type InternalModal = typeof BaseModal;

interface ExportModal extends InternalModal {
  Confirm: typeof Confirm;
  instance: typeof instance;
  Export: typeof Export;
}

const Modal = BaseModal as ExportModal;
Modal.Confirm = Confirm;
Modal.instance = instance;
Modal.Export = Export;

export default Modal;
